import { render, staticRenderFns } from "./BatchIpt.vue?vue&type=template&id=1ce0c212&scoped=true&"
import script from "./BatchIpt.vue?vue&type=script&lang=js&"
export * from "./BatchIpt.vue?vue&type=script&lang=js&"
import style0 from "./BatchIpt.vue?vue&type=style&index=0&id=1ce0c212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce0c212",
  null
  
)

export default component.exports